module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/90/assets/images/8f0535f65f025bc023bce3f2114cfca6.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Legend/Legend3.svg
// module id = wmVF
// module chunks = 1